"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDisposeInfo = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const disposeFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_cz_10',
        'ufo_cs_cz_20',
        'ufo_cs_cz_30',
        'ufo_cs_cz_40',
        'ufo_cs_cz_50',
        'ufo_cs_cz_60',
        'ufo_cs_cz_70',
        'ufo_cs_cz_80',
        'ufo_cs_cz_90', // 结束
    ]
});
disposeFlowConfig.getList = function (flowKey) {
    let index = this.$list.indexOf(flowKey);
    if (index > 0) {
        if (index > 4) {
            index = 4;
        }
        return [...this.$list.slice(index)];
    }
    else {
        return [...this.$list];
    }
};
const toDisposeInfo = function (disposeId, overdueRecordOrFlowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = disposeFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = disposeFlowConfig.getEnd();
    }
    router_1.default.push(`/handle/dispose/info/${disposeId}/${(0, utils_1.simpleEncrypt)(overdueRecordOrFlowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toDisposeInfo = toDisposeInfo;
exports.default = disposeFlowConfig;
